import { ReactComponent as HrSVG } from "../assets/hr.svg"

import './Hr.sass'

export default function Hr() {
  return <HrSVG className="Hr" />
}